import type { AppThunk } from "@Store/index";
import { fetchEditorialPageData } from "./editorialPageReducer";

const loadData = (props: any): AppThunk[] => [fetchEditorialPageData(props)];

export default loadData;
